export default {"src":"/_next/static/media/acquisition.19ab5433.svg","height":185,"width":198,"blurWidth":0,"blurHeight":0};